// Base configuration for all environments
const config = {
  development: {
    DEBUG_MODE: process.env.DEBUG_MODE || true,
    TRACKING_ENABLED: false,
    API_BASE_URL: '/api',
    WEBSOCKET_URL: window.location.origin,
    VERSION_CHECK_INTERVAL_MS: parseInt(process.env.REACT_APP_VERSION_CHECK_INTERVAL_MS) || 600000 // 10 minutes
  },
  production: {
    DEBUG_MODE: process.env.DEBUG_MODE || false,
    TRACKING_ENABLED: true,
    // Same-origin: the backend serves the SPA on every domain (prod, preprod, white-label)
    API_BASE_URL: '/api',
    WEBSOCKET_URL: window.location.origin,
    VERSION_CHECK_INTERVAL_MS: parseInt(process.env.REACT_APP_VERSION_CHECK_INTERVAL_MS) || 600000 // 10 minutes
  },
  test: {
    DEBUG_MODE: process.env.DEBUG_MODE || false,
    TRACKING_ENABLED: process.env.PLAUSIBLE_TRACK_LOCALHOST || false,
    API_BASE_URL: 'http://192.168.1.39:3003/api',
    WEBSOCKET_URL: 'http://192.168.1.39:3003',
    VERSION_CHECK_INTERVAL_MS: parseInt(process.env.REACT_APP_VERSION_CHECK_INTERVAL_MS) || 600000 // 10 minutes
  }
};

// Get current environment, fallback to 'development' if not set
let env = process.env.NODE_ENV || 'development';
// env = 'test'

console.log('[NODE_ENV]', env);

// Export the configuration for the current environment
export const API_BASE_URL = config[env].API_BASE_URL;
export const WEBSOCKET_URL = config[env].WEBSOCKET_URL;
export const DEBUG_MODE = config[env].DEBUG_MODE;
export const TRACKING_ENABLED = config[env].TRACKING_ENABLED;
export const VERSION_CHECK_INTERVAL_MS = config[env].VERSION_CHECK_INTERVAL_MS;
// Raw build-time value; the modal hook validates it (unset/invalid/past = no modal)
export const WEB_CUTOFF_DATE = (process.env.REACT_APP_WEB_CUTOFF_DATE || '').trim();
export const SUPPORT_EMAIL =
  (process.env.REACT_APP_SUPPORT_EMAIL || '').trim() || 'support@gps-merch.globe-groupe.com';

console.log('[TRACKING_ENABLED]', TRACKING_ENABLED, config);

// You can add more configuration exports here if needed
export default {
  API_BASE_URL,
  WEBSOCKET_URL,
  DEBUG_MODE,
  TRACKING_ENABLED,
  VERSION_CHECK_INTERVAL_MS
};